import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import EmptyListState from '../components/EmptyListState'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PresetRentalCard from '../components/presets/PresetRentalCard'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'
import { fetchFirestoreList } from '../utils/fetchFirestoreList'

export default function Rentals() {
  const [rentals, setRentals] = useState([])
  const [loadError, setLoadError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    ;(async () => {
      const { items, error } = await fetchFirestoreList('Rentals')
      if (!active) return
      setRentals(items)
      setLoadError(error)
      setLoading(false)
    })()
    return () => {
      active = false
    }
  }, [])

  return (
    <motion.div
      initial={{ y: -150, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <PageSeo h1="Rent a Car" />
      <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
      <PageWrapper
        name={'Rentals'}
        display={
          <h1 className="txt-big">
            <strong>
              <span className="text-success">R</span>
              <span className="text-warning">e</span>
              <span className="text-danger">n</span>
              <span className="text-success">t</span> Car
            </strong>
          </h1>
        }
      >
        <span className="txt-cream txt-shadow">
          Self-drive rentals for exploring Jamaica — Discovery Bay, Montego Bay, Ocho Rios, and Negril.
        </span>
      </PageWrapper>
      <Container style={{ marginBottom: '20vh' }}>
        {loading ? (
          <p className="text-center text-cream" role="status">Loading rentals…</p>
        ) : loadError ? (
          <EmptyListState
            title="Rentals unavailable right now"
            message="We could not load vehicles."
            permissionHint="Firestore rules may need to be deployed to allow public read access to Rentals."
            actionTo="/about-us"
            actionLabel="About Reggae Wheels"
          />
        ) : rentals.length === 0 ? (
          <EmptyListState
            title="No vehicles listed"
            message="Rental inventory will appear here when published."
            actionTo="/"
            actionLabel="Back to home"
          />
        ) : (
          <Row>
            {rentals.map((rental) => (
              <div key={rental.id + 'div'} className="col-sm-12 col-md-4 m-1">
                <PresetRentalCard className={'col-sm-12 col-md-6 col-lg-4'} rental={rental} />
              </div>
            ))}
          </Row>
        )}
      </Container>
      <Footer />
    </motion.div>
  )
}
